import React, { useState, useEffect, useContext } from 'react';
import './AccountInfo.css';
import { NumericFormat } from 'react-number-format';
import { Spin } from 'antd';
import { getApiUrl } from '../utils/configHelper';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';



const AccountInfo=({load})=> {
 
  const [accountData, setAccountData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { user } = useContext(AuthContext);

  useEffect(() => {
console.log("User in account info: -----",load); 

    const fetchAccountInfo = async () => {
      if (user && user.whatsappNumber && user.active_accesskey) {
        setLoading(true);
        try {
          const apiUrl = `${getApiUrl()}/request/getUserData?active_accesskey=${user.active_accesskey}&phoneNo=${user.whatsappNumber}`;
          const response = await axios.get(apiUrl);
          setAccountData(response.data.data);
        } catch (error) {
          console.error('Error fetching account info:', error);
          setAccountData(null);
        } finally {
          setLoading(false);
        }
      }
    };
    if(load===true){
      fetchAccountInfo();
    }
  }, [user,load]);

  return (
    <>
      <h1>Account Information</h1>
      {loading ? (
        <div className="loading-indicator">
          <Spin size="large" />
        </div>
      ) : (
        <div className="account-info-container">
          <table className="account-info-table">
            <tbody>
              <tr>
                <th>Full Name:</th>
                <td>{accountData ? accountData.firstName + " " + accountData.lastName : 'N/A'}</td>
              </tr>
              <tr>
                <th>Phone Number:</th>
                <td>
                  {accountData ? (
                    <NumericFormat
                      value={accountData.phoneNumber}
                      displayType="text"
                      format="+211 (###) ## ### ###"
                    />
                  ) : (
                    'N/A'
                  )}
                </td>
              </tr>
              <tr>
                <th>Account Balance:</th>
                <td style={{ color: accountData && accountData.accountBalance >= 0 ? 'green' : 'red' }}>
                  {accountData ? (
                    <NumericFormat
                      value={accountData.accountBalance}
                      displayType="text"
                      suffix=" SSP"
                      thousandSeparator=","
                    />
                  ) : (
                    'N/A'
                  )}
                </td>
              </tr>
              <tr>
                <th>Credit Limit:</th>
                <td>
                  {accountData ? (
                    <NumericFormat
                      value={accountData.creditLimit}
                      displayType="text"
                      suffix=" SSP"
                      thousandSeparator=","
                    />
                  ) : (
                    'N/A'
                  )}
                </td>
              </tr>
              <tr>
                <th>Status:</th>
                <td>{accountData ? accountData.status : 'N/A'}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}

export default AccountInfo;
